<template lang="pug">
.price-settings
  HScroll(:currentStep='currentStep')
    transition(name='simple-fade' mode='out-in')
      //- STEP 1 (action selector)
      ActionSelectorMenu(:items='actionItems' v-model='actionType')

    transition(name='simple-fade' mode='out-in')
      //- STEP 2 (visible if actionType is selected)
      div(v-if='actionType')
        template(v-if='actionType === "ACTION_VIEW"')
          ViewPanel
        template(v-else-if='actionType === "ACTION_EDIT"')
          UploadPanel
        template(v-else)
          GenericCard.actionDetail(size='45')
            .d-flex.flex-column.px-3.py-4
              .text-large {{ actionType }}

</template>

<script>
// import EditPersonalInfoPanelfrom '@/components/settings/panels/EditPersonalInfoPanel.vue';
// import LineApiPanel from '@/components/settings/panels/LineApiPanel.vue';
import UploadPanel from '@/components/_admin/price-settings/panels/UploadPanel.vue';
import ViewPanel from '@/components/_admin/price-settings/panels/ViewPanel.vue';

export default {
  data: () => ({
    customer: null,
    actionType: null,
    // actionDetail: null,
    receiptType: -1,
    deliveryType: -1,
    shipmentMethod: -1,
    currentStep: 0,

    filterProvince: '',

    STEP_SELECT_ACTION: 1,
    STEP_PERFORM_ACTION: 3,

    actionItems: {
      ACTION_VIEW: 'ราคาสินค้าและค่าคอม',
      ACTION_EDIT: 'แก้ไขราคาและค่าคอม',
    },
  }),
  watch: {
    actionType(newVal) {
      if (newVal) {
        this.setCurrentStep(this.STEP_SELECT_ACTION);
      }
    },
  },
  computed: {
    isActionDetailsValid() {
      return this.receiptType !== -1
          && this.deliveryType !== -1
          && this.shipmentMethod !== -1;
    },
  },
  methods: {
    setCurrentStep(step) {
      // change step to step - 1 => wait 50ms => change step to the actual value
      // so the change is always noticed by the HSrcoll component
      // HSroll will then scoll to the right, so the new view is visible to the user
      this.currentStep = step - 1;
      setTimeout(() => {
        this.currentStep = step;

        //
        // 1. PREPARE the data for each STEP
        // 2. RESET the data gathered from further steps
        //    so the data won't be mixed up
        //

        // STEP 1
        if (step < this.STEP_SELECT_ACTION) {
          this.actionType = null;
        }
      }, 50);
    },
  },
  components: {
    UploadPanel,
    ViewPanel,
  },
};
</script>

<style lang="scss">
.price-settings {
  > .h-scroll {
    height: 100%;
  }
}
</style>
